






































import { compactInspectDatabase } from '@/services/project.service';  

export default  {
  data () {
    return {
      formProjectId: "",
      error: false,
      success: false
    }
  },
  components: {
  
  },
  methods: {
    compactProject: function () {

      this.success = false
      this.error = false

      if (this.formProjectId.length > 4) {
        compactInspectDatabase(this.formProjectId).then( resp => {
          if (resp.data && resp.data.data && resp.data.data.ok) {
            this.success = true
          } else {
            this.error = true
            console.log(resp)
          }
        }).catch( e => {
          this.$store.dispatch('api_error', e)
        });


      }
      
    }
  },
  mounted() {
    this.$store.state.headerTitle = "Inspect Compact"
  },
   created () {
     
  }
}

